import {
    styled,
    Accordion as RawAccordion,
    AccordionSummary,
    Avatar,
    AccordionDetails,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {Colors, Texts} from 'appearance'

const Accordion = ({children, itemName, Icon, title, defaultExpanded}) => {
    return (
        <Container defaultExpanded={defaultExpanded}>
            <ItemHeader expandIcon={<ExpandMoreIcon />} id={itemName}>
                <Title>
                    <Avatar sx={{bgcolor: 'secondary.main'}}>
                        <Icon />
                    </Avatar>
                    <TitleText>{title}</TitleText>
                </Title>
            </ItemHeader>
            <Content>{children}</Content>
        </Container>
    )
}

export default Accordion

const Container = styled(RawAccordion)`
    width: 100%;
`
const ItemHeader = styled(AccordionSummary)`
    background: ${Colors.CARD_TITLE_BACKGROUND};
`

const TitleText = styled(Texts.BoldText)`
    font-size: 20px;
`

const Title = styled('div')`
    display: flex;
    align-items: center;
    gap: 24px;
`
const Content = styled(AccordionDetails)`
    display: flex;
    justify-content: space-between;
`
